export const BOT_TYPE = {
    MAIN_BOT: 'main_bot',
    WL_BOT: 'wl_bot',
} as const;

export type BotType = (typeof BOT_TYPE)[keyof typeof BOT_TYPE];

export const BOT_TYPE_VALUES: BotType[] = Object.values(BOT_TYPE);
